module.exports = __webpack_public_path__ + "img/ship_enemy3.13364295.png";